module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/iconfont/MaterialIcons-Regular.woff
// module id = ../../../../../src/fonts/iconfont/MaterialIcons-Regular.woff
// module chunks = 3